import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import {updateData} from '../../../routers/data'
import {fetchCalc} from '../../../routers/settings'
import InputText from '../../components/inputText'
import InputSelect from '../../components/inputSelect'
import InputDate from '../../components/inputDate'
import {FielsFilter} from '../functions'

const ParseInt = (value) => (
  (value !== undefined)? parseInt(value, 0): 0
)

const isValidDate = str => {
  const d = moment(str, 'D/M/YYYY');
  if (d == null || !d.isValid()) {
    return false;
  }

  return str.indexOf(d.format('D/M/YYYY')) >= 0
      || str.indexOf(d.format('DD/MM/YYYY')) >= 0;
}

class formPassangers extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  state = {
    calc: false,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate() {
    // check that text input's dates aren't wrong
    let datesChecked = true;
    Object.entries(this.props.data).forEach(([passenger, properties]) => {
      if ('birthDate' in properties) {
        datesChecked = datesChecked && (properties.birthDate === '' || isValidDate(properties.birthDate));
      }
    });

    // request price via calc endpoint
    if (this.state.calc && datesChecked){
      this.props.fetchCalc(this.props.data, this.props.settings)
      this.setState({calc: false});
    }
  }

  loadCalc = (name) => {
    const filter = ['locationGone', 'locationReturn', 'birthDate']
    if (filter.indexOf(name) >=0){
      this.setState({calc: true});
    }
  }

  onChange = (name, value, title, id) =>{
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume

    const filter = ['name', 'surname', 'secondSurname', 'typeDocument', 'numberDocument']
    const {index} = this.props
    const key = (this.props.name + this.props.index).toLowerCase()
    const values = this.props.data[key]
    const contact = this.props.data['contact']
    const {isPassager1} = this.props.data.values

    //Detect errors and save in state the message
    const result = FielsFilter(langPlace, name, value, contact)

    if (result.isError){
      this.props.updateData({errors: {...this.props.data.errors, [id]: result}})
    } else if (this.props.data.errors[id] !== undefined) {
      delete this.props.data.errors[id]
      this.props.updateData({errors: {...this.props.data.errors}})
    }

    //Save values in state and contact if checked 'isPassager1'
    if (index === 1 & isPassager1 & filter.some(elm => elm===name)){
      if(id === 'adult1name') {
        this.props.updateData({[key]: {...values, [name]: value}, contact: {...contact, [name]: value}})
      } else {
        this.props.updateData({[key]: {...values, [name]: value}})
      }
    } else {
      this.props.updateData({[key]: {...values, [name]: value}})
    }
    this.loadCalc(name)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume
    const langNames = languages[langUrl].dataresume.names
    const { locations, sexes, countries } = languages[langUrl]

    const errors = this.props.errors
    const {index, name} = this.props
    const {travel} = this.props.data.values
    const key = (this.props.name + this.props.index).toLowerCase()
    const values = this.props.data[key]

    // get selected travel's available places to display
    // the right basic/bunk/etc dropdown values
    const { departures, returns } = this.props.settings.available
    const { departuretravel, returntravel } = this.props.data.values
    const selectedDeparture = departures[ParseInt(departuretravel)]
    const departureAvailableSeats = selectedDeparture.availableSeats

    let selectedReturn
    let returnAvailableSeats
    if (travel === 0) { // round trip
      selectedReturn = returns[ParseInt(returntravel)]
      returnAvailableSeats = selectedReturn.availableSeats
    }

    // Thanks to Florian for this non-sense data structure which forces us to have
    // a hard time while trying to iterate over the passengers' data...
    // (╯°□°）╯︵ ┻━┻
    const getPassengersList = () => {
      const { passangers } = this.props.settings.definedData

      const passengersList = []
      for (let i = 0; i < passangers.length; i++) {
        let { name, count } = passangers[i]
        for (let k = 1; k <= this.props.data.values[count]; k++) {
          const key = `${name + k}`
          const passenger = this.props.data[key]
          passengersList.push(passenger)
        }
      }

      return passengersList;
    }

    const departureLocations = locations.filter((location) => {
      // check already taken DEPARTURE seats from all passengers
      const takenForThisLocation = getPassengersList().reduce((sum, passenger) => {
        if (!passenger) return sum;
        sum += passenger.locationGone === location.value ? 1 : 0;
        return sum;
      }, 0)

      // if (location.id === 'cabin4e') {
      //   console.log(`${key} → [cabin4e (${location.value})] taken ${takenForThisLocation} - SELECTED IS (${this.props.data[key].locationGone})`);
      // }

      return (
        this.props.data[key].locationGone === location.value || // do not remove from this one if it is already selected
        takenForThisLocation < departureAvailableSeats[location.id]
      )
    });

    let returnLocations
    if (travel === 0) { // round trip
      returnLocations = locations.filter((location) => {
        // check already taken RETURN seats from all passengers
        const takenForThisLocation = getPassengersList().reduce((sum, passenger) => {
          if (!passenger) return sum;
          sum += passenger.locationReturn === location.value ? 1 : 0;
          return sum;
        }, 0)

        return (
          this.props.data[key].locationReturn === location.value || // do not remove from this one if it is already selected
          takenForThisLocation < returnAvailableSeats[location.id]
        )
      });
    }

    return (
      <div className='col-md-6 col-sm-12 form-adult'>
        <div className='form-header'>
          <p className='title'>{langPlace.passenger}</p>
          <p className='subtitle'>{`${langPlace[name]} #${index}`}</p>
        </div>

        {(this.props.name !== 'baby')?
          (travel === 0)?
            <div>
              <div className='col-md-6 col-sm-12 no-padding'>
                <InputSelect name='locationGone' title={langNames.locationGone} value={values} autoWidth={true} array={departureLocations} errors={errors} section={key} onChange={this.onChange}/>
              </div>
              <div className='col-md-6 col-sm-12 no-padding'>
                <InputSelect name='locationReturn' title={langNames.locationReturn} value={values} autoWidth={true} array={returnLocations} errors={errors} section={key} onChange={this.onChange}/>
              </div>
            </div>
          :
            <div className='col-md-12 col-sm-12 no-padding'>
              <InputSelect name='locationGone' title={langNames.locationGone} value={values} array={departureLocations} errors={errors} section={key} onChange={this.onChange}/>
            </div>
        :
          <div className='input-text'>
            <div className='input-text-container' />
          </div>
        }

        <div className='col-md-12 col-sm-12 no-padding'>
          <InputText name='name' title={langNames.name} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-md-12 col-sm-12 no-padding'>
          <InputText name='surname' title={langNames.surname} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-md-12 col-sm-12 no-padding'>
          <InputText name='secondSurname' title={langNames.secondSurname} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-lg-6 col-md-6 col-sm-8 col-xs-6 no-padding'>
          <InputSelect name='nationality' title={langNames.nationality} value={values} autoWidth={true} array={countries} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-lg-6 col-md-6 col-sm-4 col-xs-6 no-padding'>
          <InputText name='numberDocument' title={langNames.numberDocument} value={values} errors={errors} section={key} onChange={this.onChange}/>
        </div>
        <div className='col-lg-5 col-md-5 col-sm-12 col-xs-12 no-padding'>
          <InputText name='birthDate' title={langNames.birthDate} value={values} errors={errors} section={key} onChange={this.onChange} hintText='dd/mm/yyyy'/>
        </div>
        <div className='col-lg-7 col-md-7 col-sm-4 col-xs-12 no-padding'>
          <InputSelect name='gender' title={langNames.gender} value={values} array={sexes} errors={errors} section={key} onChange={this.onChange}/>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data, errors: state.data.errors}),
  {updateData, fetchCalc}
)(formPassangers)



// WEBPACK FOOTER //
// ./src/shared/routes/routeData/components/formPassangers.js